import querystring from 'querystring';

import environment from '@/modules/cart/environments/environment';
import httpClient from '@/modules/cart/services/api/client';

import type { DeliveryGroup } from '../../domain/Cart';
import type { CartShippingMethodsRepository } from '../../domain/CartShippingMethodsRepository';

const { CART_URL } = environment;

/**
 * Returns the current local date in 'YYYY-MM-DD' format.
 *
 * @returns {string} The current date in 'YYYY-MM-DD' format (e.g., '2025-06-09').
 */
function formattedDateForCollect(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const get = async (
  commune: string,
  lineItems: string[],
  subType: 'IN_STORE' | 'COPEC'
): Promise<{ deliveryGroups: DeliveryGroup[] }> => {
  const queryData = {
    geoType: 'COMUNA',
    geoCode: commune,
    'lineItems[]': lineItems,
    startDate: formattedDateForCollect(),
    clientPreferenceShippingType: 'COLLECT',
    clientPreferenceShippingSubType: subType,
    clientPreferenceShippingMethod: 'SCHEDULED'
  };

  const query = querystring.stringify(queryData);

  const data = (
    await httpClient.get(`${CART_URL}/shipping-methods-collect?${query}`)
  ).data;

  return data;
};

const getShops = async (
  commune: string,
  lineItems: string[]
): Promise<{ deliveryGroups: DeliveryGroup[] }> => {
  return get(commune, lineItems, 'IN_STORE');
};

const getCopec = async (
  commune: string,
  lineItems: string[]
): Promise<{ deliveryGroups: DeliveryGroup[] }> => {
  return get(commune, lineItems, 'COPEC');
};

export const createCartShippingMethodsRepository =
  (): CartShippingMethodsRepository => ({
    getCopec,
    getShops
  });
